import { appSettings } from '@/config/index';
import type { FC } from 'react';

const environmentConfig = {
  development: { label: 'DEV', color: '#2563eb' },
  staging: { label: 'STAGING', color: '#d97706' },
} as const;

const EnvironmentBadge: FC = () => {
  const config = environmentConfig[appSettings.app.environment as keyof typeof environmentConfig];
  if (!config) return null;

  return (
    <div className="fixed top-0 right-0 z-50 pointer-events-none overflow-hidden w-16 h-16">
      <div
        className="absolute text-white text-[8px] font-bold tracking-wider text-center w-[90px] py-0.5"
        style={{
          backgroundColor: config.color,
          top: '10px',
          right: '-22px',
          transform: 'rotate(45deg)',
        }}
      >
        {config.label}
      </div>
    </div>
  );
};

export default EnvironmentBadge;
